import { Minus, Plus } from 'lucide-react';

import { cn } from '@/design-system/lib/cn';

export type StepperProps = {
  value: number;
  onValueChange: (value: number) => void;
  min?: number;
  max?: number;
  /** Nome do valor, para os botões e o grupo ("Quantidade de Portaria"). */
  'aria-label': string;
  disabled?: boolean;
  className?: string;
};

/** Contador − valor +, com os limites aplicados. */
export function Stepper({
  value,
  onValueChange,
  min = 0,
  max = 99,
  disabled,
  className,
  ...props
}: StepperProps) {
  const label = props['aria-label'];

  return (
    <div
      role="group"
      aria-label={label}
      className={cn(
        'flex h-9 items-center overflow-hidden rounded-control-sm border border-line-input bg-white',
        className
      )}
    >
      <button
        type="button"
        aria-label={`Diminuir ${label.toLowerCase()}`}
        disabled={disabled || value <= min}
        onClick={() => onValueChange(Math.max(min, value - 1))}
        className="grid h-full w-9 place-items-center hover:bg-surface-muted disabled:opacity-40"
      >
        <Minus aria-hidden className="size-4 stroke-[1.8]" />
      </button>
      <span aria-live="polite" data-numeric className="min-w-9 text-center font-bold">
        {value}
      </span>
      <button
        type="button"
        aria-label={`Aumentar ${label.toLowerCase()}`}
        disabled={disabled || value >= max}
        onClick={() => onValueChange(Math.min(max, value + 1))}
        className="grid h-full w-9 place-items-center hover:bg-surface-muted disabled:opacity-40"
      >
        <Plus aria-hidden className="size-4 stroke-[1.8]" />
      </button>
    </div>
  );
}
